import {TableDataTypes} from "../components/table/TableList";


export default class tableDataSubmissions{

    static columnData = [
        {name: "Student nr.", type: TableDataTypes.text, size: 2},
        {name: "Name", type: TableDataTypes.title, size: 3},
        {name: "Year", type: TableDataTypes.text, size: 1},
        {name: "VD", type: TableDataTypes.text, size: 1},
        {name: "Score", type: TableDataTypes.text, size: 2},
        {name: "Submitted", type: TableDataTypes.date, size: 2, sortable: true}
    ]


}

